export default __webpack_public_path__ + "static/media/fundos-recomendados.08dd9fcc.svg";